import React from 'react';
import { AdmissionChecklistInfo } from '../../../components/admission';
import { Header, Sidebar } from '../../../components/common';
import { LabValueInfo } from '../../../components/lab';
import { AdmissionChecklistPage } from '../admission-checklist';
import { KnowledgeItems, KnowledgePopup } from '../knowledgeItems';
import { LabValuesPage } from '../labsValues/labs-values.page';
import { UserProfilePopup } from '../user-profile';
import styles from './ApplicationFrame.module.scss';
import { AskPandaChat } from 'src/components/ai';

const ApplicationFrameComponent = React.memo(({ children }) => {
  return (
    <div className={styles.root}>
      <Header />
      <div className={styles.main}>
        <Sidebar />
        <div className={styles.content}>{children}</div>
        <KnowledgeItems />
        <KnowledgePopup />
        <LabValuesPage />
        <LabValueInfo />
        <AdmissionChecklistPage />
        <AdmissionChecklistInfo />
        <UserProfilePopup />
        <AskPandaChat />
      </div>
    </div>
  );
});

ApplicationFrameComponent.defaultProps = {};

export { ApplicationFrameComponent };
